// Environment-specific configuration
const isDevelopment = process.env.NODE_ENV === 'development';

export const GOOGLE_CONFIG = {
  CLIENT_ID: '19767887998-68mn5sn231esu9algtstc2qht01hipng.apps.googleusercontent.com',
  CLIENT_SECRET: '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',
  API_KEY: 'AIzaSyDlpq1Lsvx96DQgacpNyMLQ3pvxlP3R_ts',
  SCOPES: [
    'https://www.googleapis.com/auth/drive',
    'https://www.googleapis.com/auth/drive.file'
  ],
  
  // Development-specific settings
  REDIRECT_URI: isDevelopment ? 'http://localhost:3000' : 'https://docs.drilldocs.io',
  DOMAIN_HINT: isDevelopment ? '' : 'drilldocs.com'
};

export const DRIVE_CONFIG = {
  SHARED_DRIVES: {
    TECHNICAL_PROCESSES: '0APR0aYF2n3SqUk9PVA',
    OPERATIONAL_PROCEDURES: '0AJQUAGQGq7DEUk9PVA', 
    ONBOARDING_DOCUMENTATION: '0AN1odoPNi1LWUk9PVA',
    KNOWLEDGE_BASE: '0ACByhA6dZ95YUk9PVA'
  },
  // Legacy - keep for backwards compatibility
  SHARED_DRIVE_ID: '0APR0aYF2n3SqUk9PVA',
  TECHNICAL_PROCESSES_FOLDER: 'Technical Processes'
};

export const MIME_TYPES = {
  FOLDER: 'application/vnd.google-apps.folder',
  DOCUMENT: 'application/vnd.google-apps.document',
  SPREADSHEET: 'application/vnd.google-apps.spreadsheet',
  PRESENTATION: 'application/vnd.google-apps.presentation',
  MARKDOWN: 'text/markdown',
  TEXT: 'text/plain',
  PDF: 'application/pdf',
  PNG: 'image/png',
  JPG: 'image/jpeg',
  GIF: 'image/gif',
  SVG: 'image/svg+xml'
};

export const DOCUMENT_ICONS = {
  doc: 'M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z',
  sheet: 'M19,11H5V9H19M19,7H5V5H19M5,15H19V13H5M5,19H19V17H5V19Z',
  slides: 'M2,16V4A2,2 0 0,1 4,2H20A2,2 0 0,1 22,4V16A2,2 0 0,1 20,18H4A2,2 0 0,1 2,16M4,4V16H20V4H4M6,6H18V8H6V6M6,10H14V12H6V10M6,14H16V16H6V14Z',
  markdown: 'M2,16V8H4L6,10L8,8H10V16H8V10.83L6,12.83L4,10.83V16H2M12,8H24V10H18V16H16V10H12V8Z',
  text: 'M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z',
  pdf: 'M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20M9.5,10.5H11.5V12.5H9.5V10.5M9.5,13.5H11.5V15.5H9.5V13.5Z',
  image: 'M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z'
};